<div class="wrapper">
  <div class="icon-container" *ngIf="icon">
    <i class="icon" [ngClass]="icon"></i>
  </div>
  <div class="message-container">
    <span class="message" [ngClass]="{ 'no-margin-top': !icon }">
      {{ message }}
      <ng-content *ngIf="!message"></ng-content>
    </span>
  </div>
  <button
    [class]="buttonStyleClass || 'size-l refresh-button'"
    alg-button
    (click)="onRefresh($event)"
    *ngIf="showRefreshButton && !link"
  >{{ buttonCaption }}</button>
  <a
    class="size-l refresh-button"
    alg-button
    [routerLink]="link"
    *ngIf="link"
  >{{ buttonCaption }}</a>
</div>
